import React from "react";

export default function HeaderIconSelector({ icon, color }) {
  switch (icon) {
    case "1": {
      return (
        <svg width="56" height="56" viewBox="0 0 56 56">
          <defs>
            <linearGradient
              id="a"
              x1="0.5"
              x2="0.5"
              y2="1"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#dcae00" />
              <stop offset="1" stop-color="#dc8b00" />
            </linearGradient>
          </defs>
          <g transform="translate(-37 -89)">
            <rect
              class="a"
              width="56"
              height="56"
              transform="translate(93 145) rotate(180)"
            />
            <g transform="translate(51 102.125)">
              <g transform="translate(0 6.482)">
                <path
                  style={{ fill: `${color}` }}
                  d="M-999.978,1188.989a12.266,12.266,0,0,1-12.252-12.252,12.267,12.267,0,0,1,12.252-12.252h1.05v9.975l9.535-3.975.434.89a12.137,12.137,0,0,1,1.233,5.362A12.266,12.266,0,0,1-999.978,1188.989Zm-1.05-22.349a10.165,10.165,0,0,0-9.1,10.1,10.164,10.164,0,0,0,10.152,10.152,10.164,10.164,0,0,0,10.152-10.152,10.064,10.064,0,0,0-.631-3.534l-9.57,3.991-.511-.314a1.094,1.094,0,0,1-.49-.913Zm.714,8.4-.008,0Z"
                  transform="translate(1012.23 -1164.485)"
                />
              </g>
              <g transform="translate(15.443)">
                <path
                  style={{ fill: `${color}` }}
                  d="M-989.17,1167.936l-.512-.314a1.1,1.1,0,0,1-.49-.914v-11.482h1.05a12.171,12.171,0,0,1,11.019,6.889l.487,1Zm-.287-2.156-.008,0Zm1.385-8.4v7.823l7.538-3.144A10.06,10.06,0,0,0-988.072,1157.38Z"
                  transform="translate(990.172 -1155.227)"
                />
              </g>
              <g transform="translate(7.633 12.557)">
                <circle
                  style={{ fill: `${color}` }}
                  cx="1.084"
                  cy="1.084"
                  r="1.084"
                />
              </g>
              <g transform="translate(6.82 22.743)">
                <circle
                  style={{ fill: `${color}` }}
                  cx="1.084"
                  cy="1.084"
                  r="1.084"
                />
              </g>
              <g transform="translate(18 18.948)">
                <circle
                  style={{ fill: `${color}` }}
                  cx="1.084"
                  cy="1.084"
                  r="1.084"
                />
              </g>
              <g transform="translate(19.084 4.754)">
                <circle
                  style={{ fill: `${color}` }}
                  cx="1.084"
                  cy="1.084"
                  r="1.084"
                />
              </g>
              <g transform="translate(3.873 16.577)">
                <circle
                  style={{ fill: `${color}` }}
                  cx="2.157"
                  cy="2.157"
                  r="2.157"
                />
              </g>
              <g transform="translate(12.252 21.67)">
                <circle
                  style={{ fill: `${color}` }}
                  cx="2.157"
                  cy="2.157"
                  r="2.157"
                />
              </g>
            </g>
          </g>
        </svg>
      );
    }
    case "2": {
      return (
        <svg width="56" height="56" viewBox="0 0 56 56">
          <defs>
            <linearGradient
              id="a"
              x1="0.5"
              x2="0.5"
              y2="1"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#dcae00" />
              <stop offset="1" stop-color="#dc8b00" />
            </linearGradient>
          </defs>
          <g transform="translate(-37 -153)">
            <g transform="translate(37 153)">
              <rect
                class="a"
                width="56"
                height="56"
                transform="translate(56 56) rotate(180)"
              />
              <g transform="translate(14 14)">
                <g transform="translate(0 2.072)">
                  <path
                    style={{ fill: `${color}` }}
                    d="M-1152.379,1526.633V1514l-1.007.116-.937.109v12.409h-8.527v.963a12.366,12.366,0,0,0,12.351,12.357,12.372,12.372,0,0,0,12.358-12.357v-.963Zm1.88,11.4a10.444,10.444,0,0,1-10.388-9.47h20.775A10.444,10.444,0,0,1-1150.5,1538.028Z"
                    transform="translate(1162.85 -1514)"
                  />
                </g>
                <g transform="translate(3.901 6.455)">
                  <rect
                    style={{ fill: `${color}` }}
                    width="2.701"
                    height="1.925"
                  />
                </g>
                <g transform="translate(16.246 6.455)">
                  <rect
                    style={{ fill: `${color}` }}
                    width="11.639"
                    height="1.925"
                  />
                </g>
                <g transform="translate(3.792 2.528)">
                  <path
                    style={{ fill: `${color}` }}
                    d="M-1154.13,1514.71v1.938l-2.586.308-.225-1.912Z"
                    transform="translate(1156.94 -1514.71)"
                  />
                </g>
                <g transform="translate(13.461)">
                  <path
                    style={{ fill: `${color}` }}
                    d="M-1141.01,1513.26v.1h-.86Z"
                    transform="translate(1141.87 -1511.663)"
                  />
                  <path
                    style={{ fill: `${color}` }}
                    d="M-1125.776,1512.682l-11.754,1.4v-1.944l11.53-1.366Z"
                    transform="translate(1140.315 -1510.77)"
                  />
                </g>
                <g transform="translate(12.396 1.598)">
                  <path
                    style={{ fill: `${color}` }}
                    d="M-1141.605,1513.26v10.689h-1.925v-10.458l1.065-.128Z"
                    transform="translate(1143.53 -1513.26)"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      );
    }
    case "3": {
      return (
        <svg width="56" height="56" viewBox="0 0 56 56">
          <defs>
            <linearGradient
              id="a"
              x1="0.5"
              x2="0.5"
              y2="1"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stopColor="#dcae00" />
              <stop offset="1" stopColor="#dc8b00" />
            </linearGradient>
          </defs>
          <g transform="translate(-33 -237)">
            <rect
              class="a"
              width="56"
              height="56"
              transform="translate(89 293) rotate(180)"
            />
            <g transform="translate(47.26 249)">
              <path
                style={{ fill: `${color}` }}
                d="M5.291,14.335A9.432,9.432,0,0,1,3.83,9.2,9.432,9.432,0,0,1,5.291,4.07L6.955,5.242l-.822-.586.829.579A7.5,7.5,0,0,0,5.871,9.2,7.562,7.562,0,0,0,6.962,13.17Z"
                transform="translate(-1.008 -0.676)"
              />
              <path
                style={{ fill: `${color}` }}
                d="M12.623,9.113,11,7.948l.822.579L11,7.954a4.617,4.617,0,0,0,0-4.8L12.623,2a6.6,6.6,0,0,1,1.024,3.563A6.546,6.546,0,0,1,12.623,9.113Z"
                transform="translate(-3.099)"
              />
              <path
                style={{ fill: `${color}` }}
                d="M19.426,13.763,17.877,12.47l.775.674-.781-.674a5.977,5.977,0,0,0,.458-6.062L20.059,5.37a7.668,7.668,0,0,1,.882,4.284A7.7,7.7,0,0,1,19.426,13.763Z"
                transform="translate(-5.166 -1.1)"
              />
              <path
                style={{ fill: `${color}` }}
                d="M29.41,5.81a2.971,2.971,0,0,0-4.041,1.084l-4.91,8.48a2.732,2.732,0,0,0-.33.889,2.822,2.822,0,0,0,.034,1.347,2.7,2.7,0,0,0,.269.674h5.2L26.8,16.264l3.7-6.413A2.971,2.971,0,0,0,29.41,5.81Zm-.674,3.038-4.277,7.409-.62,1.071a.959.959,0,0,1-.573.438,1.038,1.038,0,0,1-.721-.094.959.959,0,0,1-.438-.573.928.928,0,0,1,.094-.721l.067-.121L27.107,7.9a.941.941,0,0,1,.822-.472.979.979,0,0,1,.472.121.95.95,0,0,1,.38,1.289l0,0Z"
                transform="translate(-5.464 -1.116)"
              />
              <path
                style={{ fill: `${color}` }}
                d="M.74,21.513v1A13.189,13.189,0,0,0,14.135,35.484,13.189,13.189,0,0,0,27.53,22.51V21.5ZM14.135,33.476a11.2,11.2,0,0,1-11.26-9.942h22.52A11.2,11.2,0,0,1,14.135,33.476Z"
                transform="translate(0 -5.484)"
              />
            </g>
          </g>
        </svg>
      );
    }
    case "4": {
      return (
        <svg width="56" height="56" viewBox="0 0 56 56">
          <defs>
            <linearGradient
              id="a"
              x1="0.5"
              x2="0.5"
              y2="1"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#dcae00" />
              <stop offset="1" stop-color="#dc8b00" />
            </linearGradient>
          </defs>
          <g transform="translate(-596 -469)">
            <g transform="translate(-234.221 340.27)">
              <path
                style={{ fill: `${color}` }}
                d="M868.691,158.99a4.985,4.985,0,0,1-3.94,1.65v-2.2a2.834,2.834,0,0,0,2.28-.89c1.28-1.48.92-4.41.87-4.73l-.01-.15a9.836,9.836,0,0,0-19.67-.02c-.07,1.35.12,3.85,1.26,5.06a2.352,2.352,0,0,0,1.8.73v2.2a4.475,4.475,0,0,1-3.39-1.42c-2.01-2.11-1.91-5.89-1.86-6.63a12.031,12.031,0,0,1,24.06-.03C870.231,153.62,870.491,156.92,868.691,158.99Z"
              />
              <path
                style={{ fill: `${color}` }}
                d="M873.891,169.65a3.156,3.156,0,0,1-3.15,3.15h-.01a3.67,3.67,0,0,1-3.66-3.68c.04-2.01-.42-3.92-.83-4.08l-.01-2.2a2.265,2.265,0,0,1,1.64.71c1.42,1.45,1.42,4.92,1.4,5.6a1.449,1.449,0,0,0,.43,1.02,1.485,1.485,0,0,0,1.04.43.958.958,0,0,0,.95-.96.546.546,0,0,0-.54-.54v-2.2a2.748,2.748,0,0,1,2.74,2.75Z"
              />
              <path
                style={{ fill: `${color}` }}
                d="M849.881,162.84l-.01,2.2c-.41.16-.88,2.07-.83,4.06a3.69,3.69,0,0,1-1.07,2.62,3.647,3.647,0,0,1-2.59,1.08h-.01a3.156,3.156,0,0,1-3.15-3.15,2.746,2.746,0,0,1,2.74-2.75v2.2a.546.546,0,0,0-.54.55.956.956,0,0,0,.95.95,1.485,1.485,0,0,0,1.04-.43,1.46,1.46,0,0,0,.43-1.04c-.02-.66-.02-4.13,1.4-5.58A2.265,2.265,0,0,1,849.881,162.84Z"
              />
              <path
                style={{ fill: `${color}` }}
                d="M861.811,148.68c-1.5,0-2.5,1.63-2.5,4.04s1,4.04,2.5,4.04,2.51-1.62,2.51-4.04S863.311,148.68,861.811,148.68Zm0,6.58c-.55,0-1-1.14-1-2.54s.45-2.54,1-2.54,1.01,1.14,1.01,2.54S862.371,155.26,861.811,155.26Z"
              />
              <path
                style={{ fill: `${color}` }}
                d="M854.3,148.68c-1.5,0-2.51,1.63-2.51,4.04s1.01,4.04,2.51,4.04,2.5-1.62,2.5-4.04S855.8,148.68,854.3,148.68Zm0,6.58c-.56,0-1.01-1.14-1.01-2.54s.45-2.54,1.01-2.54,1,1.14,1,2.54S854.851,155.26,854.3,155.26Z"
              />
              <path
                style={{ fill: `${color}` }}
                d="M851.911,172.84l-1.56-1.56c4.63-4.62,3.84-9.11,3.81-9.3l2.15-.43C856.361,161.79,857.411,167.34,851.911,172.84Z"
              />
              <path
                style={{ fill: `${color}` }}
                d="M865.761,171.28l-1.56,1.56c-5.5-5.5-4.45-11.05-4.41-11.29l2.16.43C861.921,162.17,861.131,166.66,865.761,171.28Z"
              />
            </g>
            <rect
              style={{ fill: `rgba(255,255,255,0)` }}
              width="56"
              height="56"
              transform="translate(652 525) rotate(180)"
            />
          </g>
        </svg>
      );
    }
    case "5": {
      return (
        <svg width="56" height="56" viewBox="0 0 56 56">
          <defs>
            <linearGradient
              id="a"
              y1="0.5"
              x2="1"
              y2="0.5"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#dcae00" />
              <stop offset="1" stop-color="#dc8b00" />
            </linearGradient>
          </defs>
          <g transform="translate(-587 -493)">
            <rect
              class="a"
              width="56"
              height="56"
              transform="translate(643 549) rotate(180)"
            />
            <path
              style={{ fill: `${color}` }}
              d="M769.847,229.687l6.08-6.85a2.188,2.188,0,0,0-.95-3.54,7.65,7.65,0,0,0-5.79-6.31,7.646,7.646,0,0,0-15.17,0,7.641,7.641,0,0,0-5.77,6.31,2.167,2.167,0,0,0-1.31,1.17,2.194,2.194,0,0,0,.36,2.37l6.08,6.85a10.983,10.983,0,0,0,7.13,3.65v2.71h-7.64v2.2h17.48v-2.2h-7.64v-2.71A10.983,10.983,0,0,0,769.847,229.687Zm-2.43-14.71a5.176,5.176,0,0,1,1.72.29,5.42,5.42,0,0,1,3.58,3.91h-9.53a.442.442,0,0,0,.15-.05,7.215,7.215,0,0,0-.48-1.68,5.444,5.444,0,0,1,4.1-2.45C767.107,214.987,767.257,214.977,767.417,214.977Zm-5.81-6.47a5.448,5.448,0,0,1,5.32,4.29,7.564,7.564,0,0,0-5.31,2.66,7.628,7.628,0,0,0-5.33-2.66A5.456,5.456,0,0,1,761.607,208.507Zm-7.53,6.76a5.234,5.234,0,0,1,1.73-.29c.15,0,.3.01.45.02a5.462,5.462,0,0,1,4.11,2.45,7.215,7.215,0,0,0-.48,1.68.476.476,0,0,0,.14.05h-9.52A5.424,5.424,0,0,1,754.077,215.267Zm7.53,15.93a8.774,8.774,0,0,1-6.59-2.97l-.19-.22-5.88-6.63h25.33l-5.89,6.63-.19.22A8.758,8.758,0,0,1,761.607,231.2Z"
              transform="translate(-146.74 298.693)"
            />
          </g>
        </svg>
      );
    }
    case "6": {
      return (
        <svg width="56" height="56" viewBox="0 0 56 56">
          <defs>
            <linearGradient
              id="a"
              x1="0.5"
              x2="0.5"
              y2="1"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#dcae00" />
              <stop offset="1" stop-color="#dc8b00" />
            </linearGradient>
          </defs>
          <g transform="translate(-878.403 -37.384)">
            <rect
              style={{ fill: `rgba(255,255,255,0)` }}
              width="56"
              height="56"
              transform="translate(878.403 37.384)"
            />
            <path
              style={{ fill: `${color}` }}
              d="M903.113,60.468a.659.659,0,1,1-.658.658A.659.659,0,0,1,903.113,60.468ZM900.95,58.3a.658.658,0,1,1-.659.659A.66.66,0,0,1,900.95,58.3Zm8.751,2.5a.659.659,0,1,1-.659.659A.66.66,0,0,1,909.7,60.8Zm5.271-1.04a.659.659,0,1,1-.659.659A.659.659,0,0,1,914.972,59.76Zm-16.623.187a.659.659,0,1,1-.659.659A.66.66,0,0,1,898.349,59.947Zm7.4-.964a.659.659,0,1,1-.659.659A.659.659,0,0,1,905.749,58.983Zm6.754-.208a.659.659,0,1,1-.659.659A.66.66,0,0,1,912.5,58.775Zm-8.96-2.274a.659.659,0,1,1-.658.659A.659.659,0,0,1,903.543,56.5Zm5.4.562a.659.659,0,1,1-.658.658A.659.659,0,0,1,908.945,57.063Zm13.262,9.776a3.935,3.935,0,0,0-1.314-2.755c.037-7.551-7.008-11.537-14.356-11.537-7.624,0-14.559,4.115-14.614,11.537a3.981,3.981,0,0,0-1.323,2.755,3.925,3.925,0,0,0,1.01,2.839,3.926,3.926,0,0,0,.34,5.6c-.3,2.893.937,4.849,3.794,4.932,1.653.019,20.538,0,21.328-.009,2.563-.092,4.152-1.837,3.785-4.9a3.971,3.971,0,0,0,1.35-3.2,3.879,3.879,0,0,0-.992-2.424A3.988,3.988,0,0,0,922.207,66.839Zm-15.8-11.656c4.8-.018,10.71,1.736,11.858,7.9l-2.342.01c-1.883.009-7.624.018-9.516,0H894.55C895.532,57.489,901.237,55.211,906.408,55.183Zm10.6,22.385c-.772.009-19.574.027-21.209.009-.91-.028-1.222-.989-1.259-2.027,8.736.11,23.726.064,23.726.064C918.22,76.5,917.9,77.54,917.008,77.568Zm1.277-3.941H894.559a1.315,1.315,0,0,1-.11-2.627H896.9a2.644,2.644,0,0,1,1.507.625,5.763,5.763,0,0,0,3.389,1.029,6.254,6.254,0,0,0,3.49-1.048A3.473,3.473,0,0,1,907,71c2.122-.018,11.335,0,11.371,0a1.315,1.315,0,0,1-.082,2.627Zm0-5.272s-9.645,0-11.583.009c-1.883,0-3.619,1.865-4.9,1.874-1.433.009-2.719-1.865-4.62-1.874-1.277-.009-2.627-.009-2.627-.009a1.318,1.318,0,1,1,0-2.636l11.564.018c.68-.009,9.406,0,10.1,0l2.085-.018a1.318,1.318,0,0,1-.018,2.636Z"
            />
          </g>
        </svg>
      );
    }

    case "7": {
      return (
        <svg width="56" height="56" viewBox="0 0 56 56">
          <defs>
            <linearGradient
              id="a"
              y1="0.5"
              x2="1"
              y2="0.5"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#dcae00" />
              <stop offset="1" stop-color="#dc8b00" />
            </linearGradient>
          </defs>
          <g transform="translate(-878.403 -266.149)">
            <g
              style={{ fill: `rgba(255,255,255,0)` }}
              transform="translate(3.51 4)"
            >
              <rect
                style={{ fill: `rgba(255,255,255,0)` }}
                width="56"
                height="56"
                transform="translate(874.894 262.149)"
              />
            </g>
            <path
              style={{ fill: `${color}` }}
              d="M918.058,290.6l-.01-.03a1.172,1.172,0,0,0-.11-.19,1.094,1.094,0,0,0-.87-.42h-5.09l2.16-8.97-2.14-.51-2.28,9.48H908.5l1.53-6.57-2.14-.5-1.65,7.07h-10.5a1.094,1.094,0,0,0-.87.42,1.182,1.182,0,0,0-.11.19l-.01.03-3,6.03,1.97.98,1.68-3.38,3.18,12.75a1.12,1.12,0,0,0,1.07.84h13.51a1.1,1.1,0,0,0,1.06-.84l3.19-12.75,1.68,3.38,1.97-.98Zm-3.42,1.56-4.06,4.66h-8.39l-4.03-4.66Zm-2.34,13.45h-11.79l-2.59-10.36,2.93,3.39a1.123,1.123,0,0,0,.84.38h9.39a1.1,1.1,0,0,0,.83-.38l2.99-3.43Z"
            />
          </g>
        </svg>
      );
    }
    case "8": {
      return (
        <svg width="56" height="56" viewBox="0 0 56 56">
          <defs>
            <linearGradient
              id="a"
              x1="0.5"
              x2="0.5"
              y2="1"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#dcae00" />
              <stop offset="1" stop-color="#dc8b00" />
            </linearGradient>
          </defs>
          <g style={{ fill: `rgba(255,255,255,0)` }}>
            <rect
              style={{ fill: `rgba(255,255,255,0)` }}
              width="56"
              height="56"
            />
          </g>
          <g transform="translate(8.8 9.965)">
            <path
              style={{ fill: `${color}` }}
              d="M35.81,5.924a11.136,11.136,0,0,0-16.066,0c-4.923,4.923-7.113,10.989-6.087,15.634l-2.9,2.9H7.728a5.729,5.729,0,0,0-1.663,11.21,5.729,5.729,0,0,0,11.21-1.663V30.977l2.9-2.9a10.628,10.628,0,0,0,2.337.281c4.338,0,9.308-2.379,13.293-6.364A11.112,11.112,0,0,0,35.81,5.924ZM16.485,26.368l-2.469,2.469a1.9,1.9,0,0,0-.559,1.35v3.819a1.9,1.9,0,0,1-3.685.657l1.216-1.216-2.7-2.7L7.071,31.964a1.9,1.9,0,0,1,.657-3.687h3.819a1.9,1.9,0,0,0,1.35-.559l2.469-2.469ZM33.11,19.29c-4.9,4.9-11.493,6.809-14.485,3.819C15.685,20.168,17.4,13.67,22.444,8.624a7.323,7.323,0,0,1,10.666,0A7.3,7.3,0,0,1,33.11,19.29Z"
              transform="translate(-2 -2.5)"
            />
          </g>
        </svg>
      );
    }
    case "9": {
      return (
        <svg width="56" height="56" viewBox="0 0 56 56">
          <defs>
            <linearGradient
              id="a"
              x1="0.5"
              x2="0.5"
              y2="1"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#dcae00" />
              <stop offset="1" stop-color="#dc8b00" />
            </linearGradient>
          </defs>
          <g style={{ fill: `rgba(255,255,255,0)` }}>
            <rect
              style={{ fill: `rgba(255,255,255,0)` }}
              width="56"
              height="56"
            />
          </g>
          <g transform="translate(8.8 9.965)">
            <path
              style={{ fill: `${color}` }}
              d="M35.81,5.924a11.136,11.136,0,0,0-16.066,0c-4.923,4.923-7.113,10.989-6.087,15.634l-2.9,2.9H7.728a5.729,5.729,0,0,0-1.663,11.21,5.729,5.729,0,0,0,11.21-1.663V30.977l2.9-2.9a10.628,10.628,0,0,0,2.337.281c4.338,0,9.308-2.379,13.293-6.364A11.112,11.112,0,0,0,35.81,5.924ZM16.485,26.368l-2.469,2.469a1.9,1.9,0,0,0-.559,1.35v3.819a1.9,1.9,0,0,1-3.685.657l1.216-1.216-2.7-2.7L7.071,31.964a1.9,1.9,0,0,1,.657-3.687h3.819a1.9,1.9,0,0,0,1.35-.559l2.469-2.469ZM33.11,19.29c-4.9,4.9-11.493,6.809-14.485,3.819C15.685,20.168,17.4,13.67,22.444,8.624a7.323,7.323,0,0,1,10.666,0A7.3,7.3,0,0,1,33.11,19.29Z"
              transform="translate(-2 -2.5)"
            />
          </g>
        </svg>
      );
    }
    case "10": {
      return (
        <svg width="56" height="56" viewBox="0 0 56 56">
          <defs>
            <linearGradient
              id="a"
              y1="0.5"
              x2="1"
              y2="0.5"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#dcae00" />
              <stop offset="1" stop-color="#dc8b00" />
            </linearGradient>
          </defs>
          <g transform="translate(-803.722 -37.384)">
            <rect
              style={{ fill: `rgba(255,255,255,0)` }}
              width="56"
              height="56"
              transform="translate(803.722 37.384)"
            />
            <path
              style={{ fill: `${color}` }}
              d="M821.167,67.529v.05c.02,0,.03-.01.05-.01C821.2,67.559,821.187,67.539,821.167,67.529Zm21.06,5.9c.01.01.03.02.04.04v-.05C842.257,73.419,842.237,73.429,842.227,73.429Z"
            />
            <path
              style={{ fill: `${color}` }}
              d="M846.787,70.389a5.322,5.322,0,0,0-1.56-3.78,5.233,5.233,0,0,0,.1-.97,4.718,4.718,0,0,0-.64-2.38l-.28-.5a5.351,5.351,0,0,0,.57-2.38v-3.63a5.281,5.281,0,0,0-5.28-5.28h-15.95a5.275,5.275,0,0,0-5.28,5.28v3.63a5.186,5.186,0,0,0,.58,2.4l-.26.44a4.782,4.782,0,0,0-.66,2.42,4.417,4.417,0,0,0,.14,1.15,5.348,5.348,0,0,0-.04,7.61,4.408,4.408,0,0,0-.1.96,4.745,4.745,0,0,0,3.04,4.44v1.5h21.1v-1.49a4.752,4.752,0,0,0,3.06-4.45,4.426,4.426,0,0,0-.15-1.15A5.343,5.343,0,0,0,846.787,70.389Zm-25.62-2.81v9.69a2.591,2.591,0,0,1-.84-1.91,2.558,2.558,0,0,1,.71-1.76,3.141,3.141,0,0,1,.13-6.02v-.05a2.55,2.55,0,0,1-.61-2.95,5,5,0,0,0,.61.41v2.54c.02.01.03.03.05.04C821.2,67.569,821.187,67.579,821.167,67.579Zm19.61-4.31-.71.26V79.1h-16.71V63.539l-.7-.27a3.116,3.116,0,0,1-1.88-2.09,2.627,2.627,0,0,1-.12-.8v-3.63a3.09,3.09,0,0,1,3.09-3.08H839.7a3.081,3.081,0,0,1,3.08,3.08v3.63a2.8,2.8,0,0,1-.12.82A3.083,3.083,0,0,1,840.777,63.269Zm1.49,10.15v.05a2.54,2.54,0,0,1,0,3.81v-3.81c-.01-.02-.03-.03-.04-.04.01,0,.03-.01.04-.01v-8.43a5.118,5.118,0,0,0,.62-.41,2.357,2.357,0,0,1,.24,1.06,2.5,2.5,0,0,1-.72,1.76,3.14,3.14,0,0,1-.14,6.02Z"
            />
          </g>
        </svg>
      );
    }
    case "11": {
      return (
        <svg width="56" height="56" viewBox="0 0 56 56">
          <defs>
            <linearGradient
              id="a"
              x1="0.5"
              x2="0.5"
              y2="1"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#dcae00" />
              <stop offset="1" stop-color="#dc8b00" />
            </linearGradient>
          </defs>
          <g transform="translate(-803.722 -121.918)">
            <g
              style={{ fill: `rgba(255,255,255,0)` }}
              transform="translate(4 4)"
            >
              <rect
                style={{ fill: `rgba(255,255,255,0)` }}
                width="56"
                height="56"
                transform="translate(799.722 117.918)"
              />
            </g>
            <rect
              class="c"
              width="20.056"
              height="2.709"
              transform="translate(819.25 164.712)"
            />
            <path
              style={{ fill: `${color}` }}
              d="M834.683,163.059h-10.81l-2.9-18h16.609Zm-8.5-2.709h6.194l2.027-12.579H824.155Z"
            />
            <path
              style={{ fill: `${color}` }}
              d="M838.711,155.1l-1.164-2.446a6.946,6.946,0,0,0,3.8-4.879h-3.265v-2.709h6.11v1.354A9.661,9.661,0,0,1,838.711,155.1Z"
            />
            <path
              style={{ fill: `${color}` }}
              d="M826.132,144.137a3.65,3.65,0,0,1-2.159-2.469c-.266-1.3.307-2.664,1.7-4.061a2.646,2.646,0,0,0,.968-1.812,1.8,1.8,0,0,0-.739-1.089l1.445-2.291a4.442,4.442,0,0,1,1.985,3.058,4.938,4.938,0,0,1-1.743,4.05c-.788.787-1.013,1.351-.967,1.6.04.214.365.439.531.511Z"
            />
            <path
              style={{ fill: `${color}` }}
              d="M831.779,144.137a3.062,3.062,0,0,1-1.811-2.081,3.679,3.679,0,0,1,1.355-3.32,1.643,1.643,0,0,0,.613-1.057,1,1,0,0,0-.37-.527l1.431-2.3a3.649,3.649,0,0,1,1.63,2.518,3.958,3.958,0,0,1-1.388,3.282c-.589.589-.614.877-.614.88.019,0,.158.089.159.09Z"
            />
          </g>
        </svg>
      );
    }
    case "12": {
      return (
        <svg width="56" height="56" viewBox="0 0 56 56">
          <defs>
            <linearGradient
              id="a"
              x1="0.5"
              x2="0.5"
              y2="1"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#dcae00" />
              <stop offset="1" stop-color="#dc8b00" />
            </linearGradient>
            <linearGradient id="c" x1="0.5" y1="0" x2="0.5" y2="1" />
          </defs>
          <g transform="translate(-803.722 -194.163)">
            <g
              style={{ fill: `rgba(255,255,255,0)` }}
              transform="translate(4 4)"
            >
              <rect
                style={{ fill: `rgba(255,255,255,0)` }}
                width="56"
                height="56"
                transform="translate(799.722 190.163)"
              />
            </g>
            <path
              style={{ fill: `${color}` }}
              d="M840.224,218l.3-2.364h-17.6l.3,2.364h-1.882v2.352h2.182l2.438,19.312h11.527l2.438-19.312h2.182V218Zm-4.812,19.312h-7.379l-1.005-7.956h9.389Zm1.3-10.309h-9.987l-.845-6.651h11.677Z"
            />
            <path
              style={{ fill: `${color}` }}
              d="M828.991,214.839a3.166,3.166,0,0,1-1.875-2.144c-.231-1.127.266-2.313,1.481-3.527a2.3,2.3,0,0,0,.839-1.573,1.558,1.558,0,0,0-.642-.946l1.255-1.989a3.85,3.85,0,0,1,1.723,2.656,4.284,4.284,0,0,1-1.513,3.516c-.684.684-.879,1.174-.84,1.386.036.186.318.381.461.443Z"
            />
            <path
              style={{ fill: `${color}` }}
              d="M833.894,214.839a2.66,2.66,0,0,1-1.573-1.807,3.2,3.2,0,0,1,1.178-2.884,1.419,1.419,0,0,0,.532-.91.83.83,0,0,0-.339-.475l1.26-1.987a3.171,3.171,0,0,1,1.415,2.187,3.435,3.435,0,0,1-1.205,2.849c-.511.511-.534.762-.534.764.022-.01.1.059.162.088Z"
            />
          </g>
        </svg>
      );
    }
    case "13": {
      return (
        <svg width="56" height="56" viewBox="0 0 56 56">
          <defs>
            <linearGradient
              id="a"
              x1="0.5"
              x2="0.5"
              y2="1"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#dcae00" />
              <stop offset="1" stop-color="#dc8b00" />
            </linearGradient>
            <linearGradient id="b" x1="0.5" y1="0" x2="0.5" y2="1" />
            <linearGradient id="c" x1="0.5" y1="0" x2="0.5" y2="1" />
            <linearGradient id="d" x1="0.5" y1="0" x2="0.5" y2="1" />
            <linearGradient id="e" x1="0.5" y1="0" x2="0.5" y2="1" />
            <linearGradient id="f" x1="0.5" y1="0" x2="0.5" y2="1" />
          </defs>
          <g transform="translate(-803.722 -266.149)">
            <g
              style={{ fill: `rgba(255,255,255,0)` }}
              transform="translate(4 4)"
            >
              <rect
                style={{ fill: `rgba(255,255,255,0)` }}
                width="56"
                height="56"
                transform="translate(799.722 262.149)"
              />
            </g>
            <path
              style={{ fill: `${color}` }}
              d="M833.587,302.174a1.263,1.263,0,1,0,1.264,1.264,1.264,1.264,0,0,0-1.264-1.264Z"
            />
            <path
              style={{ fill: `${color}` }}
              d="M829.736,292.155A1.264,1.264,0,1,0,831,293.418a1.264,1.264,0,0,0-1.264-1.263Z"
            />
            <path
              style={{ fill: `${color}` }}
              d="M833.587,295.374a1.384,1.384,0,1,0,1.384,1.384,1.384,1.384,0,0,0-1.384-1.384Z"
            />
            <path
              style={{ fill: `${color}` }}
              d="M829.736,299.045a1.053,1.053,0,1,0,1.053,1.053,1.052,1.052,0,0,0-1.053-1.053Z"
            />
            <path
              style={{ fill: `${color}` }}
              d="M829.736,305.724a1.053,1.053,0,1,0,1.053,1.053,1.053,1.053,0,0,0-1.053-1.053Z"
            />
            <path
              style={{ fill: `${color}` }}
              d="M841.1,287.736l.331-2.6H835.64l1.9-7.882-2.525-.613-2.041,8.495H822.012l.331,2.6h-2.077v2.6h2.407l2.69,21.32h12.719l2.69-21.32h2.407v-2.6Zm-5.309,21.32h-8.141l-2.372-18.724h12.885Z"
            />
          </g>
        </svg>
      );
    }
    case "14": {
      return (
        <svg width="56" height="56" viewBox="0 0 56 56">
          <defs>
            <linearGradient
              id="a"
              x1="0.5"
              x2="0.5"
              y2="1"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#dcae00" />
              <stop offset="1" stop-color="#dc8b00" />
            </linearGradient>
          </defs>
          <g style={{ fill: `rgba(255,255,255,0)` }}>
            <rect
              style={{ fill: `rgba(255,255,255,0)` }}
              width="56"
              height="56"
            />
          </g>
          <path
            style={{ fill: `${color}` }}
            d="M33.667,11a2.8,2.8,0,0,0-1.274,5.313,12.835,12.835,0,0,1-3.049,2.518c-1.178.559-2.612.669-5.594.669H23.4a14.135,14.135,0,0,0-9.8,4.25c-3.111,3.106-5.434,8.171-5.434,15.672v.68l.531.427a18.346,18.346,0,0,0,4.25,2.291A32.755,32.755,0,0,0,25.167,45c12.727,0,17-6.32,17-10.271a10.349,10.349,0,0,0-1.7-5.651c.946-.961,1.523-1.593,2.235-2.357A2.8,2.8,0,0,0,45,28a2.833,2.833,0,0,0,0-5.667,2.834,2.834,0,1,0-4.278,2.375,59.347,59.347,0,0,1-4.9,4.875c-2.665,2.292-5.7,4.084-8.533,4.084a8.712,8.712,0,0,1-5.343-2.4A1.417,1.417,0,0,0,19.9,33.229h0A11,11,0,0,0,27.292,36.5c3.968,0,7.487-2.281,10.38-4.771.243-.207.459-.423.693-.635a6.53,6.53,0,0,1,.968,3.635c0,1.755-2.364,7.438-14.166,7.438A29.857,29.857,0,0,1,14,40.19a10.308,10.308,0,0,1-2.878-1.526c.177-6.386,2.06-10.478,4.482-12.9A11.458,11.458,0,0,1,23.4,22.333c4.765,0,6.681,1.2,10.933,3.678a1.417,1.417,0,1,0,1.507-2.4l-.078-.046a46.731,46.731,0,0,0-4.7-2.462,15.657,15.657,0,0,0,3.265-2.7,2.837,2.837,0,0,0,1.079.869,2.765,2.765,0,0,0,2.192,0,2.853,2.853,0,0,0,1.737-2.606,2.771,2.771,0,0,0-.226-1.1A2.856,2.856,0,0,0,36.5,13.833,2.857,2.857,0,0,0,33.667,11Z"
          />
        </svg>
      );
    }
    case "15": {
      return (
        <svg width="56" height="56" viewBox="0 0 56 56">
          <defs>
            <linearGradient
              id="a"
              x1="0.5"
              x2="0.5"
              y2="1"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#dcae00" />
              <stop offset="1" stop-color="#dc8b00" />
            </linearGradient>
            <linearGradient id="b" x1="0.5" y1="0" x2="0.5" y2="1" />
          </defs>
          <g transform="translate(-878.403 -121.918)">
            <g
              style={{ fill: `rgba(255,255,255,0)` }}
              transform="translate(4 4)"
            >
              <rect
                style={{ fill: `rgba(255,255,255,0)` }}
                width="56"
                height="56"
                transform="translate(874.403 117.918)"
              />
            </g>
            <path
              style={{ fill: `${color}` }}
              d="M916.129,147.795a1.311,1.311,0,1,0,1.31,1.311,1.311,1.311,0,0,0-1.31-1.311Z"
            />
            <path
              style={{ fill: `${color}` }}
              d="M903.044,163.279H899.96l2.388-1.952a4.371,4.371,0,0,0,1.483-2.947,7.458,7.458,0,0,0-.591-1.781c-.149-.082-.295-.165-.442-.249a14.579,14.579,0,0,1-3.1-2.392,14.847,14.847,0,0,1-8.457,3.857l-2.144.236,1.067-1.874a12.683,12.683,0,0,0,0-12.518l-1.067-1.874,2.144.237a14.844,14.844,0,0,1,8.457,3.856,14.48,14.48,0,0,1,3.063-2.373q.237-.137.474-.267a7.568,7.568,0,0,0,.592-1.782,4.365,4.365,0,0,0-1.483-2.946l-2.388-1.952h3.084c5.2,0,9.5,2.219,10.485,5.28a14.941,14.941,0,0,1,9.905,7.571l.272.515-.273.514A14.968,14.968,0,0,1,913.527,158C912.532,161.059,908.232,163.279,903.044,163.279Zm-3.273-12.592.81.969a12.306,12.306,0,0,0,3.288,2.772c.253.145.483.276.723.4l.331.171.16.336a9.491,9.491,0,0,1,.947,3.044,5.57,5.57,0,0,1-.628,2.523c3.587-.555,5.908-2.326,6.124-3.988l.1-.807.8-.136a12.738,12.738,0,0,0,8.768-6.05,12.713,12.713,0,0,0-8.768-6.058l-.806-.136-.1-.81c-.21-1.661-2.53-3.431-6.124-3.985a5.558,5.558,0,0,1,.629,2.523,9.57,9.57,0,0,1-.946,3.042l-.16.338-.332.172c-.249.128-.488.266-.728.4a12.315,12.315,0,0,0-3.283,2.769l-.81.969-.849-.933a12.619,12.619,0,0,0-5.882-3.616,14.926,14.926,0,0,1,0,10.636,12.641,12.641,0,0,0,5.883-3.615Z"
            />
          </g>
        </svg>
      );
    }
    case "16": {
      return (
        <svg width="56" height="56" viewBox="0 0 56 56">
          <defs>
            <linearGradient
              id="a"
              x1="0.5"
              x2="0.5"
              y2="1"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#dcae00" />
              <stop offset="1" stop-color="#dc8b00" />
            </linearGradient>
          </defs>
          <g transform="translate(-951.745 -37.384)">
            <g
              style={{ fill: `rgba(255,255,255,0)` }}
              transform="translate(4 3)"
            >
              <rect
                style={{ fill: `rgba(255,255,255,0)` }}
                width="56"
                height="56"
                transform="translate(947.745 34.384)"
              />
            </g>
            <path
              style={{ fill: `${color}` }}
              d="M987.765,53.884a6.157,6.157,0,0,0-3.12.84,6.181,6.181,0,0,0-9.81,0,6.094,6.094,0,0,0-3.11-.84,6.205,6.205,0,0,0-6.2,6.2,6.389,6.389,0,0,0,4.5,6.09V77.3a3.156,3.156,0,0,0,3.14,3.16h13.16a3.156,3.156,0,0,0,3.14-3.16V66.174a6.389,6.389,0,0,0,4.5-6.09A6.205,6.205,0,0,0,987.765,53.884Zm-.5,23.42a.95.95,0,0,1-.94.96h-13.16a.95.95,0,0,1-.94-.96v-4.46h15.04Zm.97-13.12-.97.11v6.35h-15.04v-6.35l-.98-.11a4.111,4.111,0,0,1-3.52-4.1,4,4,0,0,1,4-4,3.9,3.9,0,0,1,2.67,1.03l1.1,1.02.64-1.35a3.99,3.99,0,0,1,7.21,0l.65,1.35,1.09-1.02a3.94,3.94,0,0,1,2.68-1.03,4.005,4.005,0,0,1,4,4A4.111,4.111,0,0,1,988.235,64.184Z"
            />
          </g>
        </svg>
      );
    }
    case "17": {
      return (
        <svg width="56" height="56" viewBox="0 0 56 56">
          <defs>
            <linearGradient
              id="a"
              x1="0.5"
              x2="0.5"
              y2="1"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#dcae00" />
              <stop offset="1" stop-color="#dc8b00" />
            </linearGradient>
          </defs>
          <g transform="translate(-951.745 -121.918)">
            <g
              style={{ fill: `rgba(255,255,255,0)` }}
              transform="translate(4 4)"
            >
              <rect
                style={{ fill: `rgba(255,255,255,0)` }}
                width="56"
                height="56"
                transform="translate(947.745 117.918)"
              />
            </g>
            <path
              style={{ fill: `${color}` }}
              d="M994.355,155.262l.04-.34a4.376,4.376,0,0,0,.85-2.64,4.661,4.661,0,0,0-.93-2.41l-.25-.41a2.758,2.758,0,0,1-.41-1.31c-.01-.14-.03-.3-.05-.5a9.41,9.41,0,0,0-.38-1.75c-.87-2.57-2.67-2.74-4.11-2.89l-.23-.02a1.636,1.636,0,0,1-1.39-.71,7.826,7.826,0,0,1-.45-.78,3.32,3.32,0,0,0-.78-1.07,3.05,3.05,0,0,0-2.03-.77,3.876,3.876,0,0,0-2.41.99l-.21.14a1.684,1.684,0,0,1-2.18.03l-.42-.26a4.132,4.132,0,0,0-2.45-.9c-1.53,0-2.27.84-3.15,2.02a1.871,1.871,0,0,1-1.96.97c-.13,0-.29,0-.45-.01-1.36-.03-3.21-.07-4.17,1.9a5.8,5.8,0,0,0-.47,1.97l-.05.41a2.692,2.692,0,0,1-.57,1.58l-.13.19a6.819,6.819,0,0,0-1.41,3.81,3.738,3.738,0,0,0,.55,1.94l.31.12c.19.17.12.34.01.62l-.16.42a10.358,10.358,0,0,0-.69,2.93c0,.8.24,1.55,1.95,1.63.72.01,24.89.02,27.04,0,1.25-.05,2.07-.76,2.07-1.81A11.6,11.6,0,0,0,994.355,155.262Zm-1.48,3h-26.74l.1-.46c1.21-5.36,6.62-10.9,13.58-10.9,6.52,0,11.95,5.53,13.42,10.88l.14.48Zm-.08-5.8c-3.15-4.65-7.84-7.37-12.88-7.47h-.08a16.047,16.047,0,0,0-13,7.01.01.01,0,0,0-.01.01l-.6-.44v-.02a29.379,29.379,0,0,0,1.69-3.1,6.35,6.35,0,0,0,.35-1.71c.1-.96.2-1.95,1.35-2.15a10.649,10.649,0,0,1,1.2-.04,11.915,11.915,0,0,0,1.56-.06,3.2,3.2,0,0,0,2.21-1.22c.17-.21.31-.4.45-.58.64-.86,1.2-1.6,2.61-.76l.15.1c1.23.77,2.12,1.33,3.54.98a5.022,5.022,0,0,0,1.61-.84c.54-.37,1.01-.7,1.53-.59a1.35,1.35,0,0,1,.83.69l.09.16c1.12,1.94,1.26,2.19,4.28,2.54,1.74.24,1.92,1.9,2.1,3.5l.04.36a9.952,9.952,0,0,0,1.6,3.21Z"
            />
          </g>
        </svg>
      );
    }
    case "18": {
      return (
        <svg width="56" height="56" viewBox="0 0 56 56">
          <defs>
            <linearGradient
              id="a"
              x1="0.5"
              x2="0.5"
              y2="1"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#dcae00" />
              <stop offset="1" stop-color="#dc8b00" />
            </linearGradient>
          </defs>
          <g transform="translate(-951.745 -194.163)">
            <g
              style={{ fill: `rgba(255,255,255,0)` }}
              transform="translate(4 4)"
            >
              <rect
                style={{ fill: `rgba(255,255,255,0)` }}
                width="56"
                height="56"
                transform="translate(947.745 190.163)"
              />
            </g>
            <g transform="translate(-0.831 -0.816)">
              <path
                style={{ fill: `${color}` }}
                d="M996.479,215.8l-3.1-2.444.084-.306a1.152,1.152,0,0,0-.4-1.222l-3.73-2.95a1.163,1.163,0,0,0-1.075-.2,1.09,1.09,0,0,0-.59.464,1.138,1.138,0,0,0-.7-.643L982.509,207a1.167,1.167,0,0,0-1.022.137,1.181,1.181,0,0,0-.506.906l-.084,1.949a1.22,1.22,0,0,0-.485-.337l-4.467-1.644a1.155,1.155,0,0,0-1.559,1.138l.01.327-4.183-1.865a1.159,1.159,0,0,0-1.191.158,1.136,1.136,0,0,0-.421,1.127l.938,4.8-3.867-.99a1.167,1.167,0,0,0-1.422,1.349l1.38,7.07a1.529,1.529,0,0,0,.053.211.2.2,0,0,0,.021.074l6.943,16.9a1.161,1.161,0,0,0,1.075.716h13.886a1.161,1.161,0,0,0,1.075-.716l6.953-16.91a.194.194,0,0,0,.021-.074c.01-.021.021-.032.021-.053l.021-.095,1.18-4.151A1.152,1.152,0,0,0,996.479,215.8Zm-9.05,8.639.337-6.111v-.063a.951.951,0,0,0-.042-.295.869.869,0,0,0-.084-.232c-.01-.021-.01-.032-.021-.042l.99-3.582.653-2.339,1.76,1.391-.01.053a.893.893,0,0,0-.095.232l-.716,2.571-.274,1a.7.7,0,0,0-.021.074l-.738,2.644-.063.221-.021.095-.242.843-.917,3.266h-.01c-.084.053-.158.095-.242.137s-.158.105-.242.148Zm-4.467-8.629.084-1.991.179-4.141,2.181.727-.19,3.34-.158,2.781-.716-.242-1.38-.464Zm-.042,9.567a.134.134,0,0,0,.01-.063v-.084l.3-6.88,1.728.579.443.147-.032.622v.011l-.327,5.911v.011c-.316.137-.632.263-.927.369a7.01,7.01,0,0,1-.706.242,1.811,1.811,0,0,1-.221.074c-.105.032-.211.053-.306.084Zm-4.035-13.823.105,2.265v.042l.548,12.78c-.211-.042-.443-.074-.674-.137-.021,0-.032-.011-.053-.011l-1.707-8.808-.19-3.93-.137-2.982Zm-5.331.074.464,2.349.79,4.067,1.475,7.575A20.785,20.785,0,0,1,974,224.5l-1.623-8.355-1.075-5.51Zm-6.68,3.782,2.16.548.284,1.433.938,4.752c-1.117-.79-1.981-1.464-2.413-1.812Zm25.023,9-5.068,12.3H974.5L969.444,224.4c.116.084.242.169.369.253.021.011,2.6,1.623,2.623,1.623a25.061,25.061,0,0,0,3.477,1.707c.516.2,1.591.579,1.612.579a14.6,14.6,0,0,0,1.665.369c.158.032,1.148.126,1.475.126h.084c.3,0,1.475-.137,1.591-.158a17.159,17.159,0,0,0,4.3-1.443c.032-.011.906-.443,1.054-.516.19-.105.39-.211.579-.316.39-.211.759-.421,1.117-.622.021-.011.032-.021.053-.032a.22.22,0,0,0,.063-.042.424.424,0,0,0,.095-.053c.411-.242.811-.5,1.191-.748.2-.126.39-.242.569-.369.095-.063.179-.116.274-.179a2.307,2.307,0,0,1,.263-.179Zm1.644-4.12c-.274.221-.759.611-1.391,1.075-.116.095-.242.179-.369.274-.284.211-.59.421-.917.653l.537-1.918.01-.074.748-2.644v-.011l.516-1.833.021-.053,1.738,1.38Z"
              />
            </g>
          </g>
        </svg>
      );
    }
    case "19": {
      return (
        <svg width="56" height="56" viewBox="0 0 56 56">
          <defs>
            <linearGradient
              id="a"
              x1="0.5"
              x2="0.5"
              y2="1"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#dcae00" />
              <stop offset="1" stop-color="#dc8b00" />
            </linearGradient>
          </defs>
          <g transform="translate(-951.745 -266.149)">
            <g
              style={{ fill: `rgba(255,255,255,0)` }}
              transform="translate(4 4)"
            >
              <rect
                style={{ fill: `rgba(255,255,255,0)` }}
                width="56"
                height="56"
                transform="translate(947.745 262.149)"
              />
            </g>
            <circle
              style={{ fill: `${color}` }}
              cx="0.75"
              cy="0.75"
              r="0.75"
              transform="translate(980.365 299.868)"
            />
            <circle
              style={{ fill: `${color}` }}
              cx="0.75"
              cy="0.75"
              r="0.75"
              transform="translate(977.624 299.868)"
            />
            <circle
              style={{ fill: `${color}` }}
              cx="0.75"
              cy="0.75"
              r="0.75"
              transform="translate(980.365 305.788)"
            />
            <circle
              style={{ fill: `${color}` }}
              cx="0.75"
              cy="0.75"
              r="0.75"
              transform="translate(977.624 305.788)"
            />
            <circle
              style={{ fill: `${color}` }}
              cx="0.75"
              cy="0.75"
              r="0.75"
              transform="translate(980.365 308.321)"
            />
            <circle
              style={{ fill: `${color}` }}
              cx="0.75"
              cy="0.75"
              r="0.75"
              transform="translate(977.624 308.321)"
            />
            <path
              style={{ fill: `${color}` }}
              d="M984.12,278.29h-8.76a3.813,3.813,0,0,0-3.8,3.81v12.83a1.573,1.573,0,0,0,1.57,1.57h.65a1.413,1.413,0,0,0-1.33,1.41,7.295,7.295,0,0,0,14.59,0,1.413,1.413,0,0,0-1.33-1.41h.64a1.581,1.581,0,0,0,1.58-1.57V282.1A3.815,3.815,0,0,0,984.12,278.29ZM979.75,303a5.1,5.1,0,0,1-5.04-4.31h10.07A5.1,5.1,0,0,1,979.75,303Zm5.98-8.7H973.76V282.1a1.6,1.6,0,0,1,1.6-1.6h8.76a1.6,1.6,0,0,1,1.61,1.6Z"
            />
          </g>
        </svg>
      );
    }
    case "20": {
      return (
        <svg width="56" height="56" viewBox="0 0 56 56">
          <defs>
            <linearGradient
              id="a"
              x1="0.5"
              x2="0.5"
              y2="1"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#dcae00" />
              <stop offset="1" stop-color="#dc8b00" />
            </linearGradient>
          </defs>
          <g transform="translate(-1028.851 -37.384)">
            <g
              style={{ fill: `rgba(255,255,255,0)` }}
              transform="translate(4 3)"
            >
              <rect
                style={{ fill: `rgba(255,255,255,0)` }}
                width="56"
                height="56"
                transform="translate(1024.851 34.384)"
              />
            </g>
            <path
              style={{ fill: `${color}` }}
              d="M1056.851,57.669c-4.09,0-7.4.56-7.4,1.24s3.31,1.23,7.4,1.23V68.8a1.235,1.235,0,0,0,2.47,0v-8.73c.9-.05,1.74-.13,2.46-.24v13.93a1.235,1.235,0,0,0,2.47,0V58.909C1064.251,58.229,1060.941,57.669,1056.851,57.669Zm0,0c-4.09,0-7.4.56-7.4,1.24s3.31,1.23,7.4,1.23V68.8a1.235,1.235,0,0,0,2.47,0v-8.73c.9-.05,1.74-.13,2.46-.24v13.93a1.235,1.235,0,0,0,2.47,0V58.909C1064.251,58.229,1060.941,57.669,1056.851,57.669Zm0,0c-4.09,0-7.4.56-7.4,1.24s3.31,1.23,7.4,1.23V68.8a1.235,1.235,0,0,0,2.47,0v-8.73c.9-.05,1.74-.13,2.46-.24v13.93a1.235,1.235,0,0,0,2.47,0V58.909C1064.251,58.229,1060.941,57.669,1056.851,57.669Zm0,0c-4.09,0-7.4.56-7.4,1.24s3.31,1.23,7.4,1.23V68.8a1.235,1.235,0,0,0,2.47,0v-8.73c.9-.05,1.74-.13,2.46-.24v13.93a1.235,1.235,0,0,0,2.47,0V58.909C1064.251,58.229,1060.941,57.669,1056.851,57.669Zm13.7,3.72a3.542,3.542,0,0,0,1.1-2.48c0-4.06-7.4-6.09-14.8-6.09s-14.8,2.03-14.8,6.09a3.537,3.537,0,0,0,1.1,2.47,3.347,3.347,0,0,0,.01,4.97,3.615,3.615,0,0,0-1.11,2.47,3.556,3.556,0,0,0,1.1,2.47,3.618,3.618,0,0,0-1.1,2.48,3.83,3.83,0,0,0,1.5,2.86,10.316,10.316,0,0,0,3.28,1.79,33.575,33.575,0,0,0,20.04,0,10.688,10.688,0,0,0,3.29-1.79,3.832,3.832,0,0,0,1.49-2.85,3.653,3.653,0,0,0-1.11-2.49,3.512,3.512,0,0,0,1.11-2.48,3.578,3.578,0,0,0-1.1-2.47,3.518,3.518,0,0,0,1.1-2.48A3.612,3.612,0,0,0,1070.551,61.389Zm-2.06,1.48c.41.35.69.7.69.99,0,.62-.91,1.37-2.46,2.03v2.67a14.04,14.04,0,0,0,1.8-.76,1.561,1.561,0,0,1,.66,1.01c0,.62-.91,1.37-2.46,2.04v2.68a16,16,0,0,0,1.75-.77c.48.42.71.78.71,1s-.12.54-.63.99a8.506,8.506,0,0,1-2.53,1.35,28.233,28.233,0,0,1-9.17,1.37,27.675,27.675,0,0,1-9.17-1.38,8.444,8.444,0,0,1-2.52-1.34c-.52-.45-.64-.78-.64-1s.15-.57.69-1.02c2.85,1.48,7.25,2.26,11.64,2.26.82,0,1.65-.03,2.47-.08v-2.48c-.79.06-1.61.09-2.47.09-7.41,0-12.33-2.23-12.33-3.71a1.592,1.592,0,0,1,.68-1,24.419,24.419,0,0,0,9.18,2.15v-2.48c-6.01-.42-9.86-2.31-9.86-3.62a1.539,1.539,0,0,1,.66-1.01,24.425,24.425,0,0,0,9.2,2.16v-2.48c-6.01-.42-9.86-2.31-9.86-3.62,0-1.48,4.92-3.71,12.33-3.71s12.33,2.23,12.33,3.71c0,.62-.91,1.37-2.46,2.03v2.67A16.971,16.971,0,0,0,1068.491,62.869Zm-11.64-5.2c-4.09,0-7.4.56-7.4,1.24s3.31,1.23,7.4,1.23V68.8a1.235,1.235,0,0,0,2.47,0v-8.73c.9-.05,1.74-.13,2.46-.24v13.93a1.235,1.235,0,0,0,2.47,0V58.909C1064.251,58.229,1060.941,57.669,1056.851,57.669Zm0,0c-4.09,0-7.4.56-7.4,1.24s3.31,1.23,7.4,1.23V68.8a1.235,1.235,0,0,0,2.47,0v-8.73c.9-.05,1.74-.13,2.46-.24v13.93a1.235,1.235,0,0,0,2.47,0V58.909C1064.251,58.229,1060.941,57.669,1056.851,57.669Zm0,0c-4.09,0-7.4.56-7.4,1.24s3.31,1.23,7.4,1.23V68.8a1.235,1.235,0,0,0,2.47,0v-8.73c.9-.05,1.74-.13,2.46-.24v13.93a1.235,1.235,0,0,0,2.47,0V58.909C1064.251,58.229,1060.941,57.669,1056.851,57.669Z"
            />
            <path
              style={{ fill: `${color}` }}
              d="M1064.251,73.759a1.235,1.235,0,0,1-2.47,0V59.829c-.72.11-1.56.19-2.46.24V68.8a1.235,1.235,0,0,1-2.47,0v-8.66c-4.09,0-7.4-.55-7.4-1.23s3.31-1.24,7.4-1.24,7.4.56,7.4,1.24Z"
            />
          </g>
        </svg>
      );
    }
    case "21": {
      return (
        <svg width="56" height="56" viewBox="0 0 56 56">
          <defs>
            <linearGradient
              id="a"
              x1="0.5"
              x2="0.5"
              y2="1"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#dcae00" />
              <stop offset="1" stop-color="#dc8b00" />
            </linearGradient>
          </defs>
          <g transform="translate(-1028.851 -121.918)">
            <g
              style={{ fill: `rgba(255,255,255,0)` }}
              transform="translate(4 4)"
            >
              <rect
                style={{ fill: `rgba(255,255,255,0)` }}
                width="56"
                height="56"
                transform="translate(1024.851 117.918)"
              />
            </g>
            <path
              style={{ fill: `${color}` }}
              d="M1071.094,151.228a25.258,25.258,0,0,0-3.38-5.74c-2.3-2.96-5.84-6.01-10.6-6.13a.967.967,0,0,0-.29-.04.925.925,0,0,0-.23.04c-4.78.1-8.32,3.17-10.62,6.13a25.631,25.631,0,0,0-3.42,5.83.944.944,0,0,0-.13.75v.01l.01.03a.433.433,0,0,0,.01.05l.01.03a.3.3,0,0,0,.04.08.487.487,0,0,1,.03.07l3.38,5.78a1.009,1.009,0,0,0,.32.33,12.669,12.669,0,0,0,2.68,1.07,28.8,28.8,0,0,0,7.94,1,28.365,28.365,0,0,0,7.94-1,12.669,12.669,0,0,0,2.68-1.07,1.01,1.01,0,0,0,.32-.33l3.34-5.72.03-.06A.947.947,0,0,0,1071.094,151.228Zm-4.82,5.65a8.462,8.462,0,0,1-2.03.79,30.221,30.221,0,0,1-14.8,0,8.44,8.44,0,0,1-2.04-.79l-1.36-2.34a5.583,5.583,0,0,0,1.41.2,4.968,4.968,0,0,0,3.54-1.42,3.792,3.792,0,0,0,5.32.6,4.338,4.338,0,0,0,.53-.52,3.767,3.767,0,0,0,5.33.44,3.643,3.643,0,0,0,.52-.52,4.926,4.926,0,0,0,3.53,1.42,5.237,5.237,0,0,0,1.42-.2Zm-.05-4.06c-1.57,0-2.64-.98-2.64-1.93v-.95a.976.976,0,0,0-.95-.98h-.03a.95.95,0,0,0-.94.96v.96a1.93,1.93,0,1,1-3.86.01v-.95a.963.963,0,0,0-.95-.98h-.03a.969.969,0,0,0-.95.98v.95a1.925,1.925,0,1,1-3.85,0v-.95a.954.954,0,0,0-.94-.98h-.03a.956.956,0,0,0-.95.98v.95c0,.95-1.07,1.93-2.65,1.93a2.408,2.408,0,0,1-2.62-1.83,22.006,22.006,0,0,1,2.66-4.32,14.881,14.881,0,0,1,5.52-4.57,9.874,9.874,0,0,0-.92,1.69.963.963,0,0,0,1.79.71.035.035,0,0,0,.01-.02,7.59,7.59,0,0,1,.52-.94,6.3,6.3,0,0,1,1.47-1.69v2.29a.96.96,0,0,0,.96.96.934.934,0,0,0,.97-.88v-2.37a7.735,7.735,0,0,1,1.99,2.63.96.96,0,1,0,1.81-.64c0-.02-.01-.03-.02-.05a9.777,9.777,0,0,0-.92-1.68,14.84,14.84,0,0,1,5.52,4.56,22.8,22.8,0,0,1,2.66,4.32A2.42,2.42,0,0,1,1066.224,152.818Z"
            />
          </g>
        </svg>
      );
    }
    case "22": {
      return (
        <svg width="56" height="56" viewBox="0 0 56 56">
          <defs>
            <linearGradient
              id="a"
              x1="0.5"
              x2="0.5"
              y2="1"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#dcae00" />
              <stop offset="1" stop-color="#dc8b00" />
            </linearGradient>
          </defs>
          <g transform="translate(-1028.851 -194.163)">
            <g
              style={{ fill: `rgba(255,255,255,0)` }}
              transform="translate(4 4)"
            >
              <rect
                style={{ fill: `rgba(255,255,255,0)` }}
                width="56"
                height="56"
                transform="translate(1024.851 190.163)"
              />
            </g>
            <path
              style={{ fill: `${color}` }}
              d="M1067,227.235a10.867,10.867,0,0,1-3.234-.368c.037-.089.075-.172.112-.254a1.014,1.014,0,0,0-.551-1.325,1.05,1.05,0,0,0-.14-.047,15.259,15.259,0,0,1-2.579-1.33l.073-.088a1.015,1.015,0,0,0,.028-1.251,24.189,24.189,0,0,0-4.239-4.243,1.016,1.016,0,0,0-1.277,0l-.088.074a15.276,15.276,0,0,1-1.329-2.578,1.015,1.015,0,0,0-1.231-.738.928.928,0,0,0-.135.044c-.089.037-.173.075-.254.112a10.517,10.517,0,0,1-.381-3.233,2.858,2.858,0,0,0-2.791-3.045c-1.756,0-2.859,1.69-3.231,2.681a16.083,16.083,0,0,0-1.1,7.319c-.275.159-.474.277-.507.294a1.015,1.015,0,0,0-.494.888l.014,1a16.454,16.454,0,0,0,.993,5.8l-.634.519a1.014,1.014,0,0,0-.321,1.107c.047.139,1.195,3.437,6.532,6.64a1.014,1.014,0,0,0,1.306-.229l.534-.645a16.346,16.346,0,0,0,5.774,1.007l1.015.014h.014a1.017,1.017,0,0,0,.871-.492c.018-.031.134-.23.293-.508.455.032.912.065,1.342.065a15.937,15.937,0,0,0,5.971-1.164c1-.38,2.688-1.476,2.688-3.234A2.86,2.86,0,0,0,1067,227.235Zm-19.349-14.865c.11-.29.666-1.375,1.333-1.375s.762.715.762,1.015a12.379,12.379,0,0,0,.539,4.052c-1.381.634-2.639,1.269-3.649,1.807A13.894,13.894,0,0,1,1047.653,212.37Zm-1.952,8.761v-.423a69.934,69.934,0,0,1,6.546-3.3c.381.775.9,1.667,1.276,2.295l-7.183,5.869A14.854,14.854,0,0,1,1045.7,221.131Zm4.842,11.874a14,14,0,0,1-4.6-4.478l9.9-8.1a22.5,22.5,0,0,1,2.76,2.736Zm7.324.306a14.756,14.756,0,0,1-4.422-.647l5.868-7.173c.634.381,1.507.9,2.293,1.279a69.829,69.829,0,0,1-3.3,6.547Zm8.771-1.949a13.918,13.918,0,0,1-5.5,1.015c.538-1.015,1.172-2.27,1.808-3.65a12.339,12.339,0,0,0,4.042.539c.31.006,1.025.091,1.025.761S1066.933,231.249,1066.638,231.362Z"
            />
          </g>
        </svg>
      );
    }
    case "23": {
      return (
        <svg width="56" height="56" viewBox="0 0 56 56">
          <defs>
            <linearGradient
              id="a"
              x1="0.5"
              x2="0.5"
              y2="1"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#dcae00" />
              <stop offset="1" stop-color="#dc8b00" />
            </linearGradient>
            <linearGradient id="b" x1="0.5" y1="0" x2="0.5" y2="1" />
          </defs>
          <g transform="translate(-1028.851 -266.149)">
            <g
              style={{ fill: `rgba(255,255,255,0)` }}
              transform="translate(4 4)"
            >
              <rect
                style={{ fill: `rgba(255,255,255,0)` }}
                width="56"
                height="56"
                transform="translate(1024.851 262.149)"
              />
            </g>
            <path
              style={{ fill: `${color}` }}
              d="M1070.93,294.149c0-.03-.01-.06-.01-.08a5.963,5.963,0,0,0-.2-1.09c-1.16-4.24-2.91-6.29-10.69-8.06-6.02-1.36-14.33-2.44-16.81,3.92a8.462,8.462,0,0,0-.56,3.02c-.01.64-.08,6.34,1.19,8.48a7.865,7.865,0,0,0,7.05,4.08,14.981,14.981,0,0,0,6.07-1.49,6.218,6.218,0,0,1,4.33-.35c2.97.9,7.04,2.12,8.98-1.35C1070.98,299.979,1071.21,295.7,1070.93,294.149Zm-2.57,6c-.83,1.48-2.33,1.56-6.43.33a8.4,8.4,0,0,0-5.86.44c-4.91,2.19-8.38,1.62-10.33-1.69a4.27,4.27,0,0,1-.39-1.08,7.739,7.739,0,0,0,5.55,2.16,15.017,15.017,0,0,0,6.07-1.5,6.271,6.271,0,0,1,4.33-.34c2.29.69,5.24,1.58,7.36.35A4.772,4.772,0,0,1,1068.36,300.149Zm0-4.11c-.83,1.48-2.33,1.56-6.43.33a8.4,8.4,0,0,0-5.86.44,12.938,12.938,0,0,1-5.17,1.3,5.662,5.662,0,0,1-5.16-2.99,6.6,6.6,0,0,1-.88-3.22,6.235,6.235,0,0,1,.41-2.26c.93-2.38,3.19-3.55,6.97-3.55a34.161,34.161,0,0,1,7.31.98c7.05,1.6,8.13,3.13,9.05,6.49A3.281,3.281,0,0,1,1068.36,296.039Z"
            />
            <path
              style={{ fill: `${color}` }}
              d="M1050.37,287.989a3.64,3.64,0,1,0,3.64,3.64A3.647,3.647,0,0,0,1050.37,287.989Zm0,5.08a1.44,1.44,0,1,1,1.44-1.44A1.447,1.447,0,0,1,1050.37,293.069Z"
            />
          </g>
        </svg>
      );
    }
    case "24": {
      return (
        <svg width="56" height="56" viewBox="0 0 56 56">
          <defs>
            <linearGradient
              id="a"
              y1="0.5"
              x2="1"
              y2="0.5"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#dcae00" />
              <stop offset="1" stop-color="#dc8b00" />
            </linearGradient>
            <linearGradient id="b" x1="0.5" y1="0" x2="0.5" y2="1" />
            <linearGradient id="c" x1="0.5" y1="0" x2="0.5" y2="1" />
          </defs>
          <g transform="translate(-1104.681 -37.384)">
            <g
              style={{ fill: `rgba(255,255,255,0)` }}
              transform="translate(4 3)"
            >
              <rect
                style={{ fill: `rgba(255,255,255,0)` }}
                width="56"
                height="56"
                transform="translate(1100.681 34.384)"
              />
            </g>
            <path
              style={{ fill: `${color}` }}
              d="M1133.371,58.879l-.34-.82a5.313,5.313,0,0,0,1.98-3.69,7.328,7.328,0,0,0-1.35-3.99l-1.75,1.34a4.99,4.99,0,0,1,.9,2.65c0,1.01-1.28,2.13-1.73,2.43l-.74.51.69,1.66a11.8,11.8,0,1,0,2.34-.09Zm-.69,21.31a9.57,9.57,0,1,1,9.57-9.57A9.577,9.577,0,0,1,1132.681,80.189Z"
            />
            <path
              style={{ fill: `${color}` }}
              d="M1132.915,76.885a7.58,7.58,0,0,1-6.738-4,.5.5,0,0,1,.9-.437,6.582,6.582,0,0,0,5.839,3.436,5.56,5.56,0,0,0,5.352-3.387.5.5,0,0,1,.94.339A6.654,6.654,0,0,1,1132.915,76.885Z"
            />
            <circle
              style={{ fill: `${color}` }}
              cx="1.639"
              cy="1.639"
              r="1.639"
              transform="translate(1127.087 66.074)"
            />
            <circle
              style={{ fill: `${color}` }}
              cx="1.639"
              cy="1.639"
              r="1.639"
              transform="translate(1135 66.074)"
            />
          </g>
        </svg>
      );
    }
    case "25": {
      return (
        <svg width="56" height="56" viewBox="0 0 56 56">
          <defs></defs>
          <rect
            style={{ fill: `rgba(255,255,255,0)` }}
            width="56"
            height="56"
            transform="translate(56 56) rotate(180)"
          />
          <g transform="translate(14.875 15.75)">
            <path
              style={{ fill: `${color}` }}
              d="M585.382,319.96H570.174v-13.3h-5.617V296.247H591V306.66h-5.618ZM572.1,318.034h11.357v-13.3h5.618v-6.562H566.482v6.563H572.1Z"
              transform="translate(-564.557 -296.247)"
            />
            <g transform="translate(12.257 9.449)">
              <rect style={{ fill: `${color}` }} width="1.925" height="9.851" />
            </g>
          </g>
        </svg>
      );
    }
    case "26": {
      return (
        <svg width="56" height="56" viewBox="0 0 56 56">
          <defs></defs>
          <g transform="translate(-32 -767)">
            <rect
              style={{ fill: `rgba(255,255,255,0)` }}
              width="56"
              height="56"
              transform="translate(88 823) rotate(180)"
            />
            <g transform="translate(46 784.5)">
              <g transform="translate(0 18.017)">
                <rect
                  style={{ fill: `${color}` }}
                  width="27.722"
                  height="2.286"
                />
              </g>
              <g transform="translate(1.911)">
                <path
                  style={{ fill: `${color}` }}
                  d="M693.22,354.264H669.314l.233-1.339a11.833,11.833,0,0,1,8.145-9.3,3.892,3.892,0,1,1,7.161,0,11.851,11.851,0,0,1,8.133,9.292Zm-21.088-2.286H690.4a9.569,9.569,0,0,0-7.711-6.5l-1.408-.207-1.431.208A9.547,9.547,0,0,0,672.132,351.978Zm9.145-11.478a1.6,1.6,0,0,0-.932,2.912l.917.647.945-.653a1.58,1.58,0,0,0,.671-1.3A1.6,1.6,0,0,0,681.277,340.5Z"
                  transform="translate(-669.314 -338.213)"
                />
              </g>
            </g>
          </g>
        </svg>
      );
    }
    case "fb": {
      return (
        <svg width="32" height="32" viewBox="0 0 32 32" className="mr-2">
          <defs>
            <style>{`.aaa,.bbb{fill:#000000;}.bbb{opacity:0;}`}</style>
          </defs>
          <g transform="translate(-832 -502)">
            <g transform="translate(222 -2685)">
              <g transform="translate(614 3191)">
                <path d="M24,12A12,12,0,1,0,10.125,23.854V15.469H7.078V12h3.047V9.356c0-3.008,1.792-4.669,4.533-4.669a18.453,18.453,0,0,1,2.686.234V7.875H15.831a1.734,1.734,0,0,0-1.956,1.874V12H17.2l-.532,3.469h-2.8v8.385A12,12,0,0,0,24,12Z" />
                <path
                  class="aaa"
                  d="M311.593,210.781l.532-3.469H308.8v-2.251a1.734,1.734,0,0,1,1.956-1.874h1.513v-2.953a18.453,18.453,0,0,0-2.686-.234c-2.741,0-4.533,1.661-4.533,4.669v2.644H302v3.469h3.047v8.385a12.127,12.127,0,0,0,3.75,0v-8.385Z"
                  transform="translate(-294.922 -195.313)"
                />
              </g>
            </g>
            <rect
              class="bbb"
              width="32"
              height="32"
              transform="translate(832 502)"
            />
          </g>
        </svg>
      );
    }
    case "ig": {
      return (
        <svg width="32" height="32" viewBox="0 0 32 32" className="mr-2">
          <defs>
            <style>{`.aaa{fill:#fff;opacity:0;}`}</style>
          </defs>
          <g transform="translate(-895 -502)">
            <g transform="translate(107 -2896)">
              <g transform="translate(792 3402)">
                <path
                  d="M16.079,6.241c3.2,0,3.584.012,4.849.07a6.642,6.642,0,0,1,2.228.413A3.974,3.974,0,0,1,25.434,9a6.642,6.642,0,0,1,.413,2.228c.058,1.265.07,1.645.07,4.849s-.012,3.584-.07,4.849a6.642,6.642,0,0,1-.413,2.228,3.974,3.974,0,0,1-2.277,2.277,6.642,6.642,0,0,1-2.228.413c-1.265.058-1.645.07-4.849.07s-3.584-.012-4.849-.07A6.642,6.642,0,0,1,9,25.434a3.974,3.974,0,0,1-2.277-2.277,6.642,6.642,0,0,1-.413-2.228c-.058-1.265-.07-1.645-.07-4.849s.012-3.584.07-4.849A6.642,6.642,0,0,1,6.724,9,3.974,3.974,0,0,1,9,6.724a6.642,6.642,0,0,1,2.228-.413c1.265-.058,1.645-.07,4.849-.07m0-2.162c-3.259,0-3.668.014-4.948.072a8.808,8.808,0,0,0-2.913.558,6.136,6.136,0,0,0-3.51,3.51,8.808,8.808,0,0,0-.558,2.913c-.058,1.28-.072,1.689-.072,4.948s.014,3.668.072,4.948a8.808,8.808,0,0,0,.558,2.913,6.136,6.136,0,0,0,3.51,3.51,8.808,8.808,0,0,0,2.913.558c1.28.058,1.689.072,4.948.072s3.668-.014,4.948-.072a8.808,8.808,0,0,0,2.913-.558,6.136,6.136,0,0,0,3.51-3.51,8.808,8.808,0,0,0,.558-2.913c.058-1.28.072-1.689.072-4.948s-.014-3.668-.072-4.948a8.808,8.808,0,0,0-.558-2.913,6.136,6.136,0,0,0-3.51-3.51,8.808,8.808,0,0,0-2.913-.558c-1.28-.058-1.689-.072-4.948-.072Z"
                  transform="translate(-4.079 -4.079)"
                />
                <path
                  d="M132.8,126.635a6.162,6.162,0,1,0,6.162,6.162A6.162,6.162,0,0,0,132.8,126.635Zm0,10.162a4,4,0,1,1,4-4A4,4,0,0,1,132.8,136.8Z"
                  transform="translate(-120.797 -120.797)"
                />
                <circle
                  cx="1.44"
                  cy="1.44"
                  r="1.44"
                  transform="translate(16.966 4.154)"
                />
              </g>
            </g>
            <rect
              class="aaa"
              width="32"
              height="32"
              transform="translate(895 502)"
            />
          </g>
        </svg>
      );
    }
    default: {
      return <i class="icon-font">{icon}</i>;
    }
  }
}
